import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from './store/UserContext';
import { ProtectedRoute, AuthRoute } from './store/ProtectedRoute';
import CartAndSummary from './Pages/CartAndSummary';
import Home from './Pages/Home';
import Order from './Pages/Order';
import ViewProductDetails from './Pages/ViewProductDetails';
import ContactUsMain from './Pages/ContactUsMain';
import AccountPro from './Pages/AccountPro';
import HomePanel from './admin_panel/Pages/HomePanel';
import AddProduct from './admin_panel/Pages/AddProduct';
import Signup from './Pages/Signup';
import Login from './Pages/Login';
import AdminLogin from './admin_panel/Pages/AdminLogin';
import PlaceOrder from './Pages/PlaceOrder';
import EditProduct from './admin_panel/Pages/EditProducts';
import Orders from './admin_panel/Pages/Orders';
import AllUsers from './admin_panel/Pages/AllUsers';
import GetAboutUs from './admin_panel/Pages/GetAboutUs';
import Debug from './Pages/Debug';
import DebugNav from './admin_panel/Components/AdminNav/DebugNav';
function App() {
  return (
    <div className="App">
      <UserProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/debug' element={<Debug />} />
            <Route path='/cart' element={<CartAndSummary />} />
            <Route path='/place-order' element={<PlaceOrder />} />
            
            <Route path='/orders' element={
              <ProtectedRoute>
                <Order />
              </ProtectedRoute>
            } />
            
            <Route path='/view-product-details/:id' element={<ViewProductDetails />} />
            <Route path='/contact-us' element={<ContactUsMain />} />
            
            <Route path='/account' element={
              <ProtectedRoute>
                <AccountPro />
              </ProtectedRoute>
            } />
            
            <Route path='/admin-home' element={
              <ProtectedRoute adminOnly>
                <HomePanel />
              </ProtectedRoute>
            } />

            <Route path='/admin-debug' element={
              <ProtectedRoute adminOnly>
                < DebugNav   />
              </ProtectedRoute>
            } />

             <Route path='/all-users' element={
              <ProtectedRoute adminOnly>
                <AllUsers />
              </ProtectedRoute>
            } />
            
            <Route path='/add-products' element={
              <ProtectedRoute adminOnly>
                <AddProduct />
              </ProtectedRoute>
            } />
            
            <Route path='/edit-product/:id' element={
              <ProtectedRoute adminOnly>
                <EditProduct />
              </ProtectedRoute>
            } />

            <Route path='/orders-all' element={
              <ProtectedRoute adminOnly>
                <Orders />
              </ProtectedRoute>
            } />

            <Route path='/get-about-us' element={
              <ProtectedRoute adminOnly>
                <GetAboutUs />
              </ProtectedRoute>
            } />
            
            <Route path='/signup' element={
              <AuthRoute>
                <Signup />
              </AuthRoute>
            } />
            
            <Route path='/login' element={
              <AuthRoute>
                <Login />
              </AuthRoute>
            } />
            
            <Route path='/admin-login' element={<AdminLogin />} />  
          </Routes>
        </Router>
      </UserProvider>
    </div>
  );
}

export default App;